import React, { useState } from 'react';
import { Card, Row, Col, Input, Button, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { FaEye, FaEdit, FaFilter, FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const DashboardTables = ({
  doctorsData,
  ecommerceData,
  CustomerColumns,
  DoctorColumns,
  NewStatus,
  header,
  sort,
  add,
  totalRows,
  DoctorTotalRows,
  handlePageChangeDoctor,
  handlePageChange,
  onChangePage,
  handlePerRowsChangeDoctor,
  handlePerRowsChange,
  resetPaginationToggle
}) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('doctors');

  const Navigate = () => {
    navigate("/add_new_rfq");
  };

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: '#f8f9fa',
        borderBottom: 'none',
      },
    },
    headCells: {
      style: {
        color: '#6c757d',
        fontSize: '0.9rem',
        fontWeight: '600',
        paddingLeft: '8px',
        paddingRight: '8px',
      },
    },
    rows: {
      style: {
        fontSize: '0.9rem',
        paddingLeft: '8px',
        paddingRight: '8px',
      },
    },
  };

  const TabButton = ({ id, label, subtitle }) => (
    <button
      onClick={() => setActiveTab(id)}
      className={`text-base font-normal pb-2 mr-8 focus:outline-none transition-colors duration-200 ${activeTab === id
        ? 'text-blue-600 border-b-2 border-blue-600'
        : 'text-gray-500 hover:text-gray-700'
        }`}
      style={{
        borderBottom: activeTab === id ? '2px solid #3488A4' : 'none',
        color: activeTab === id ? '#3488A4' : '#718096',
        background: 'none',
        border: 'none',
        fontSize: '16px',
        borderRadius: 0,
        marginLeft: '15px',
        padding: '0 0 8px 0',
      }}
    >
      {label}
      {subtitle && (
        <span className="text-sm text-gray-500 ml-2">
          {subtitle}
        </span>
      )}
    </button>
  );

  return (
    <Card className="mt-4 mb-4">
      <div className="p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h4 className="mb-0">{header}</h4>
            <div className="mt-3">
              <div className="flex">
                <TabButton id="doctors" label="Doctors Orders" />
                <TabButton stye={{ marginLeft: '10px' }}
                  id="ecommerce"
                  label="Ecommerce Orders"
                  subtitle={`(${NewStatus.pendingOrders} New, ${NewStatus.ProcessedOrders} Processing)`}
                />
              </div>
            </div>
          </div>
          <div>
            {sort && (
              <UncontrolledDropdown className="me-2 d-inline-block">
                <DropdownToggle caret color="light">
                  Sort by <FaFilter size={14} />
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem>Date</DropdownItem>
                  <DropdownItem>Status</DropdownItem>
                  <DropdownItem>Total Item</DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            )}
            {add && (
              <Button onClick={Navigate} className="bg-[#3D607A] border-[#3D607A]">
                Add New <FaPlus size={14} className="ml-1" />
              </Button>
            )}
          </div>
        </div>

        {activeTab === 'doctors' ? (
          <DataTable
            columns={DoctorColumns}
            data={doctorsData || []}
            pagination
            paginationServer
            paginationTotalRows={DoctorTotalRows}
            onChangePage={handlePageChangeDoctor}
            onChangeRowsPerPage={handlePerRowsChangeDoctor}
            fixedHeader
            fixedHeaderScrollHeight="400px"
            customStyles={customStyles}
            paginationResetDefaultPage={resetPaginationToggle}

          />
        ) : (
          <DataTable
            columns={CustomerColumns}
            data={ecommerceData || []}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
            fixedHeader
            fixedHeaderScrollHeight="400px"
            customStyles={customStyles}
            paginationResetDefaultPage={resetPaginationToggle}
          />
        )}
      </div>
    </Card>
  );
};

export default DashboardTables;